/**
 * Notification entity descriptors (platform `@rammetec/data-access/notifications`).
 *
 * Registered under {@link NOTIFICATION_ENTITY} names so system-api / clients can
 * resolve repositories via the entity registry. N15: Firestore-only until
 * system-api can write PostgresRest (request 0093).
 */
import { CacheStrategy, DataSourceStrategy } from '@rammetec/data-access';
import { createNotificationDescriptors, NOTIFICATION_ENTITY, } from '@rammetec/data-access/notifications';
import { SYSTEM_ALLOWED_DATA_SOURCES } from './dataSourcePolicy.js';
export const notificationDescriptors = createNotificationDescriptors({
    dataSource: DataSourceStrategy.Firestore,
    allowedDataSources: SYSTEM_ALLOWED_DATA_SOURCES,
    // Live list — no InMemory cache (sininho / page must see writes immediately).
    cache: CacheStrategy.NoCache,
});
export { NOTIFICATION_ENTITY };
//# sourceMappingURL=notifications.descriptor.js.map